<div class="page-layout carded fullwidth inner-scroll">
    <mat-toolbar-row class="secondary-header">
        <app-top-cards fxFlex="100"></app-top-cards>
    </mat-toolbar-row>
    <div class="center px-20">
        <div class="content-card mt-12 mb-84">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>